// extracted by mini-css-extract-plugin
export default {"calculateBtn":"Controls_calculateBtn__9+Weg","resetBtn":"Controls_resetBtn__3W9OJ"};